module.exports = __webpack_public_path__ + "img/takeasmnt.097a03af.svg";